import { css } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';

import SheetAnimationNameEnum from '../../enums/SheetAnimationNameEnum.js';
import SheetStateEnum from '../../enums/SheetStateEnum.js';

const TRANSITION_TIME = '0.2s';

export default class SheetBackdropStyle {
	/**
	 * Returns styles.
	 *
	 * @param options Options object.
	 * @param options.state Sheet state.
	 * @param options.theme Theme.
	 * @returns Styles.
	 */
	public static getStyle(options: { state: string; theme: ITheme }): string {
		return css`
			:host {
				display: block;
			}
			:host,
			.container {
				position: absolute;
				top: 0;
				left: 0;
				bottom: 0;
				right: 0;
				z-index: inherit;
			}
			.container {
				cursor: inherit;
			}

			${this.getStateStyle(options.state)}
			${this.getBackdropColor()}
		`;
	}

	/**
	 * Returns styles.
	 *
	 * @returns Styles.
	 */
	private static getBackdropColor(): string {
		return css`
			.container {
				background: rgba(0, 0, 0, 0.15);
				cursor: inherit;
			}
		`;
	}

	/**
	 * Returns state dependent styling.
	 *
	 * @param state Props. Open|closed.
	 * @returns Styles.
	 */
	private static getStateStyle(state: string): string {
		switch (state) {
			case SheetStateEnum.open:
				return this.getOpenStyle();
			case SheetStateEnum.closed:
				return this.getClosedStyle();
			case SheetStateEnum.closing:
				return this.getClosingtyle();
			case SheetStateEnum.opening:
				return this.getOpeningStyle();
		}

		return '';
	}

	/**
	 * Returns styles.
	 *
	 * @returns Styles.
	 */
	private static getClosingtyle(): string {
		return css`
			@keyframes ${SheetAnimationNameEnum.closing} {
				from {
					opacity: 1;
				}
				to {
					opacity: 0;
				}
			}
			:host {
				pointer-events: none;
			}
			.container {
				animation-name: ${SheetAnimationNameEnum.closing};
				animation-duration: ${TRANSITION_TIME};
				animation-fill-mode: both;
				animation-timing-function: ease-in-out;
			}
		`;
	}

	/**
	 * Returns styles.
	 *
	 * @returns Styles.
	 */
	private static getClosedStyle(): string {
		return css`
			:host {
				pointer-events: none;
				visibility: hidden;
			}
		`;
	}

	/**
	 * Returns styles.
	 *
	 * @returns Styles.
	 */
	private static getOpeningStyle(): string {
		return css`
			@keyframes ${SheetAnimationNameEnum.opening} {
				from {
					opacity: 0;
				}
				to {
					opacity: 1;
				}
			}
			:host {
				pointer-events: none;
			}
			.container {
				animation-name: ${SheetAnimationNameEnum.opening};
				animation-duration: ${TRANSITION_TIME};
				animation-fill-mode: both;
				animation-timing-function: ease-in-out;
			}
		`;
	}

	/**
	 * Returns styles.
	 *
	 * @returns Styles.
	 */
	private static getOpenStyle(): string {
		return css``;
	}
}
